import { NgModule, SkipSelf, Optional } from '@angular/core';
import { ContextModule } from './context/context.module';

@NgModule({
  imports: [ContextModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded');
    }
  }
}
